import React from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import CustomEmailServerTab from './CustomEmailServerTab';
import MailerLiteTab from './MailerLiteTab';

const STORAGE_KEY = 'admin_mail_provider';

type Provider = 'mailerlite' | 'custom';

const MailProvidersTab: React.FC = () => {
  const [provider, setProvider] = React.useState<Provider>(() => {
    const saved = (localStorage.getItem(STORAGE_KEY) || 'mailerlite') as Provider;
    return saved === 'custom' || saved === 'mailerlite' ? saved : 'mailerlite';
  });

  const handleChange = (_: React.SyntheticEvent, value: Provider) => {
    setProvider(value);
    localStorage.setItem(STORAGE_KEY, value);
  };

  return (
    <Box>
      <Paper elevation={0} sx={{ mb: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Tabs
          value={provider}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="Mail providers"
          sx={{ width: '100%' }}
        >
          <Tab label="Mail Campaigns (MailerLite)" value="mailerlite" />
          <Tab label="Mail Notifications (Custom Email Server)" value="custom" />
        </Tabs>
      </Paper>

      {provider === 'mailerlite' && (
        <Box>
          <MailerLiteTab />
        </Box>
      )}

      {provider === 'custom' && (
        <Box>
          <CustomEmailServerTab />
        </Box>
      )}
    </Box>
  );
};

export default MailProvidersTab;
